import api from "./axios-setup/axios";

/**
 * Create a new organization
 * @param {object} payload - Organization details
 * @returns {Promise<object>} Newly created organization
 */
export const createOrganization = async (payload) => {
  const response = await api.post("/organizations", payload);
  return response.data;
};

/**
 * Get all organizations with pagination
 * @param {number} [skip=0] - Number of records to skip
 * @param {number} [limit=10] - Number of records to return
 * @returns {Promise<object[]>} Array of organizations
 */
export const listOrganizations = async (skip = 0, limit = 10) => {
  const response = await api.get("/organizations", {
    params: { skip, limit },
  });
  return response.data;
};

/**
 * Get a single organization by ID
 * @param {string} id - Organization ID (UUID)
 * @returns {Promise<object>} Organization data
 */
export const getOrganizationByID = async (id) => {
  const response = await api.get(`/organizations/${id}`);
  return response.data;
};

/**
 * Update an organization by ID
 * @param {string} id - Organization ID (UUID)
 * @param {object} payload - Fields to update
 * @returns {Promise<object>} Updated organization
 */
export const updateOrganizationById = async (id, payload) => {
  const response = await api.put(`/organizations/${id}`, payload);
  return response.data;
};

/**
 * Delete an organization by ID
 * @param {string} id - Organization ID (UUID)
 * @returns {Promise<object>} Response from server
 */
export const deleteOrganizationById = async (id) => {
  const response = await api.delete(`/organizations/${id}`);
  return response.data;
};
